module.exports = __webpack_public_path__ + "img/CapInventario.23b8209b.png";